module.exports = __webpack_public_path__ + "static/media/landing-logos-m.a9407dc6.png";